import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=b04e592a&scoped=true"
import script from "./Chips.vue?vue&type=script&lang=js"
export * from "./Chips.vue?vue&type=script&lang=js"
import style0 from "./Chips.vue?vue&type=style&index=0&id=b04e592a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04e592a",
  null
  
)

export default component.exports